__turbopack_context__.v({
  "root": "styles-module-scss-module__BkXYzq__root",
});
